<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10">
      <el-col :span="6">
        <div class="aside">
          <h4 class="aside-title">商家入驻指南</h4>
          <ul class="aside-list">
            <li class="aside-item">签订入驻协议</li>
            <li class="aside-item">填写商家资料</li>
            <li class="aside-item">平台审核</li>
            <li class="aside-item active">合同签订及缴费</li>
            <li class="aside-item">店铺开通</li>
          </ul>
        </div>
        <div class="aside">
          <h4 class="aside-title">平台联系方式</h4>
          <ul class="aside-list">
            <li class="aside-item">电话：400-0456880</li>
            <li class="aside-item">邮箱：18748424242@163.com</li>
          </ul>
        </div>
      </el-col>
      <el-col :span="18" class="rightaside">
        <el-card shadow="never">
          <div class="table-header" slot="header">
            店铺资料审核已通过，请联系平台人员缴纳保证金。
          </div>
          <table class="table" v-if="applyStoreData">
            <caption>付款清单列表</caption>
            <tr>
              <td class="table-label">收费标准:</td>
              <td class="table-text">{{ applyStoreData.levelName }}</td>
              <td class="table-label">开店时长:</td>
              <td class="table-text">{{ applyStoreData.time }}</td>
            </tr>
            <tr>
              <td class="table-label">经营类:</td>
              <td class="table-text">
                <div class="one-line-text">{{ applyStoreData.types }}</div>
              </td>
              <td class="table-label">开店保证金:</td>
              <td class="table-text">{{ applyStoreData.margin | decimal }} 元</td>
            </tr>
            <tr>
              <td class="table-label">已缴保证金:</td>
              <td class="table-text">
                <div class="one-line-text">{{ (applyStoreData.marginPaidAmount + applyStoreData.marginAuditAmount) | decimal }}元</div>
              </td>
              <td class="table-label"></td>
              <td class="table-text"></td>
            </tr>
          </table>
          <div class="btn-box" v-if="shouldPayAmount > 0">
            <el-button type="primary" @click="show">立即上传支付凭证</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 支付保证金弹窗 -->
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal='false'
      width="30%"
      class="paydialogBox">
      <div class="textCenter">
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="支付金额" prop="amount" :rules="[
            {required: true, message: '请输入支付金额'},
            {type: 'number', min: 0, max: shouldPayAmount, message: '金额超限'},
          ]">
            <el-input type="number" v-model.number="form.amount">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="支付凭证" prop="payPic" :rules="{required: true, message: '请上传支付凭证'}">
            <el-upload
              name="files"
              class="avatar-uploader"
              :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
              :show-file-list="false"
              :on-success="handleSuccess"
              :before-upload="beforeUpload">
              <img v-if="form.payPic" :src="form.payPic" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitApply" class="buttonBgd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {addMargin} from '../../api/xunyou'
export default {
  data() {
    return {
      visible: false,
      form: {
        amount: null,
        payPic: ''
      }
    };
  },
  computed: {
    applyStoreData () {
      return this.$store.state.applyStoreData;
    },
    shouldPayAmount () {
      let amount = 0;
      if (this.applyStoreData) {
        amount = this.applyStoreData.margin - this.applyStoreData.marginPaidAmount - this.applyStoreData.marginAuditAmount;
      }
      return amount;
    }
  },
  methods: {
    show () {
      this.visible = true;
    },
    hide () {
      this.visible = false;
      this.form.amount = null;
      this.form.payPic = null;
    },
    // 点击支付保证金调起的按钮
    submitApply() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          addMargin({
            remittanceUrl: this.form.payPic,
            amount: this.form.amount,
            muid: this.$store.getters.userId,
          }).then(res => {
              if (res.code === 0) {
                this.hide();
                this.$store.dispatch('getStoreData');
                this.$router.replace('/settleIn/merchantStatus');
                this.$message.success("提交保证金凭据成功,请等待管理员审核!");
              } else {
                this.$message.error(res.msg);
              }
            })
        }
      });
    },
    //   支付凭证上传
    handleSuccess(res, file) {
      this.form.payPic = res.url;
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .el-card__header{
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 500;
}
.table {
  width: 100%;
  border-left: 1px solid #dcdfe6;

  caption {
    background-color: #dcdfe6;
    font-size: 16px;
    font-weight: bold;
    padding: 10px;
    text-align: left;
  }

  td {
    padding: 8px 10px;
    border-right: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
  }
}

.table-label {
  width: 100px;
}

.one-line-text {
  max-width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.breakcrumbHeader {
  margin: 15px 0;
}

.aside {
  box-sizing: border-box;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 40px;
  background-color: #fff;

  .aside-title {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    font-weight: 700;
  }

  .aside-item {
    padding: 10px;

    &.active {
      color: var(--main-theme-color);
    }
  }
}
.btn-box{
  margin-top: 20px;
  text-align: right;
}
.avatar-uploader{
  width: 120px;
  height: 120px;
  border: 1px solid #ddd;
  border-radius: 4px;
  .avatar{
    width: 100%;
    height: 100%;
  }
  /deep/ .el-upload{
    width: 100%;
    height: 100%;
    .el-icon-plus{
      font-size: 30px;
      line-height: 120px;
    }
  }
}

</style>







// WEBPACK FOOTER //
// src/views/merchantSettled/menchantpayFor.vue